module.exports = __webpack_public_path__ + "img/requirement-money@2x.36cc8b9a.png";